<template>


    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-list-check-2"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                                <p class="cf-modal-head__sub">Liste</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between " style="display: block">



                            <div class="grid grid-cols-12  gap-x-6">


                                <div class=" xl:col-span-12  col-span-12 mt-4 mb-4">
                                    <input v-model="searchword" class="form-control form-control-lg w-full" type="text"
                                           placeholder="Rechercher"
                                           aria-label=".form-control-lg example">
                                </div>



                                <div class=" xl:col-span-4  col-span-12 mt-4 mb-4">
                                    <label >Utilisateur :</label>
                                    <select v-model="useraccescaisse.user" style=" display: inline-block; margin: 0 5px; padding: 2px 25px;
                                            border: 1px solid #aaa; border-radius: 3px;" class="ti-form-select rounded-sm !py-2 !px-3 form-control w-full">
                                        <option :value="null">Séléctionner un utilisateur</option>
                                        <option v-for="(user,index) of otherdata.us" :key="index" :value="user">{{user.pname}}</option>

                                    </select>
                                </div>

                                <div class=" xl:col-span-4  col-span-12 mt-4 mb-4">
                                    <label >Caisse :</label>
                                    <select v-model="useraccescaisse.caisse" style=" display: inline-block; margin: 0 5px; padding: 2px 25px;
                                            border: 1px solid #aaa; border-radius: 3px;" class="ti-form-select rounded-sm !py-2 !px-3 form-control w-full">
                                        <option :value="null">Séléctionner une caisse</option>
                                        <option v-for="(caisse,index) of otherdata.ca" :key="index" :value="caisse">{{caisse.name}}</option>

                                    </select>
                                </div>
                                <div class=" xl:col-span-4  col-span-12 mt-4 mb-4">
                                    <label >&nbsp;&nbsp;</label>
                                    <button style="color:white;background-color: #218838;border-color: #1e7e34;" @click="autorisationacces"
                                            class="form-control ti-btn ti-btn-success-full w-full"><i class="ri-settings-2-line"></i> Autoriser l'accès à la caisse</button>

                                </div>




                            </div>


                            <div class="w-full grid grid-cols-1">


                            </div>






                        </div>


                        <div class="box-body !p-0 mybodyheight300px">
                            <div class="table-responsive">

                                <!-- component -->
                                <div class="flex flex-col h-screen">
                                    <div class="flex-grow overflow-auto">

                                        <table class="relative w-full border table mytable table-hover whitespace-nowrap min-w-full">
                                            <thead>
                                            <tr>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">N°</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">Nom caisse</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">Utilisateur</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">Créer le</th>
                                                <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-start">Action</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            <template v-if="filterdatatable.length">

                                                <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light" v-for="(datavalue,index) in filterdatatable" :key="index">

                                                    <td data-label="N°  : ">{{index+1}}</td>
                                                    <td  data-label="Nom caisse  : "   >{{ datavalue.infocc.us.pname }}</td>
                                                    <td  data-label="Utilisateur  : "   >{{datavalue.infocc.ca.name}}</td>
                                                    <td  data-label="Créer le  : "   >{{ datavalue.creerler }}</td>

                                                     <td  data-label="Action  : "   >


                                                        <div class="ti-btn-group">
                                                            <div class="cf-actions">
                                                            <button @click="btnsuppression(datavalue)" class="cf-iconbtn cf-iconbtn--danger" title="Retirer ce l'accès"><i class="ri-remote-control-2-fill"></i></button>
                                                        </div>
                                                        </div>




                                                    </td>

                                                </tr>



                                            </template>


                                            <template v-else>
                                                <tr >
                                                    <td colspan="20"><div class="alert alert-danger text-center">Aucun enregistrement n'a été trouvé.</div></td>
                                                </tr>

                                            </template>



                                            </tbody>
                                        </table>


                                    </div>
                                </div>

                            </div>
                        </div>





                        <div class="flex flex-col box-footer border-t-0 ">
                            <div class="flex items-center flex-wrap overflow-auto">
                                <div class="mb-2 sm:mb-0">

                                </div>
                                <div class="ms-auto">


                                    <nav aria-label="Page navigation">
                                        <ul class="ti-pagination mb-0">
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page <= 1 }" class="page-link px-3 py-[0.375rem]" @click="page--">Previous</button>
                                            </li>
                                            <li class="page-item">
                                                <button class="page-link px-3 py-[0.375rem]" :class="{ 'active': pageNumber === page }"
                                                        :key="key" v-for="(pageNumber, key) in displayedPages" @click="page = pageNumber">
                                                    {{ pageNumber }}
                                                </button>
                                            </li>
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page >= pages.length }" class="page-link px-3 py-[0.375rem]" @click="page++">Next</button>
                                            </li>
                                        </ul>
                                    </nav>





                                </div>
                            </div>
                        </div>
                    </div>






                </div>
                <div class="cf-dialog-foot">


                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full" >
                        Fermer
                    </button>


                </div>
                </div>
            </Transition>
        </div>
    </Transition>

  <modalformsuppression @closed="load"  ref="modalformsuppression"></modalformsuppression>

</template>

<script>
    /* import templatesite from "@/components/template/apptemplate";
     import appheader from "@/components/template/appheader";
     import appsidebar from "@/components/template/appsidebar";*/


    const axios =require('axios');

    import modalformsuppression from "@/components/views/pages/setting/accesscaisse/formsuppression";


    import { randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },
          /*  searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

                // console.log("  oldvalue  searchtrierletableau        **************** ",oldvalue)
                // console.log("  newvalue   searchtrierletableau       **************** ",newvalue)

            }*/

        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;


                if (this.searchword!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {
                        return    post.infocc.us.pname.toLowerCase().includes(t.searchword.toLowerCase()) ||
                             post.infocc.ca.name.toLowerCase().includes(t.searchword.toLowerCase())

                    })

                }



                return this.paginate(mvalue) ;
            },
        },
        components: {
            modalformsuppression

        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",
                datatable:[],
                listedupersonnel:[],
                otherdata:[],
                datatiers:[],
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                niveaudacces:{},

                useraccescaisse:{
                    user:null,
                    caisse:null
                },





                searchword:"",
                searchtrierletableau:"",

                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],
            };
        },
        methods: {



            async load(){



                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl7adminacces771714dfe/access/'+this.$store.state.appsociete+'/895418initaccess519151911515/'+randomString(200);
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){



                            t.datatable=[];
                            t.otherdata=[];
                            t.datatable=res.data.m;
                            t.otherdata=res.data.alldata;
                             t.isdisplay=true;

                        }
                        else{
                            t.otherdata=res.data.alldata;
                            t.datatable=[];
                           // t.alldata=[];

                            t.isdisplay=true;

                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },



            btnsuppression(value){



                let titlemodal="VOULLEZ-VOUS VRAIMENT RETIRER L'ACCES ?";

                this.$refs.modalformsuppression.show(titlemodal,value,this.typedoc);

            },

            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

           async autorisationacces(){

                if (
                    this.useraccescaisse.caisse===null ||
                    this.useraccescaisse.user===null
                )
                {
                    toastr['error']( 'Veuillez saisir toutes les informations',"<b>Enregistrement</b>");
                    this.$store.dispatch('lancerchargement',false)
                    return
                }

                this.$store.dispatch('lancerchargement',true);

                this.useraccescaisse.caisse={...this.useraccescaisse.caisse,...{'opencaisse':0,'dateopen':''}}


                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl7adminacces771714dfe/access/'+this.$store.state.appsociete+'/add89541accesscaisse519151911515/'+randomString(200);
                let response =   axios  .post(url,this.useraccescaisse,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })
                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){

                            t.messagesucces="";
                            t.messageerror="";

                            t.useraccescaisse={
                                user:null,
                                    caisse:null
                            }

                            t.messagesucces=res.data.message;

                            toastr['success']( t.messagesucces,"<b></b>");


                            t.load()

                        }
                        else{

                            let errormessage="";

                            t.messageerror="";
                            t.messagesucces="";
                            if (res.data.datamessage.length>0){

                                for (let message of res.data.datamessage){

                                    if (errormessage===""){

                                        errormessage=message;

                                    }else{

                                        errormessage+=" , "+message;

                                    }


                                }


                                t.messageerror=errormessage;

                            }
                            else{
                                t.messageerror=res.data.message
                            }


                            toastr['error'](t.messageerror,"<b></b>");
                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b>Erreur</b>")
                    )
                    .finally(() => this.$store.dispatch('lancerchargement',false))










            },

            show(){


                this.messagesucces="";
                this.messageerror="";
                this.titlemodal="Liste des accès à la caisse"
                /* this.datatable=listdata
                 */

                this.load()



            },






            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-th { background:var(--cf-surface-alt)!important; color:var(--cf-ink)!important; font-weight:600; font-size:0.75rem; letter-spacing:0.02em; }
.cf-actions { display:inline-flex; align-items:center; gap:4px; }
.cf-iconbtn { height:2rem; width:2rem; display:inline-flex; align-items:center; justify-content:center; border:none; border-radius:var(--cf-radius-sm); cursor:pointer; font-size:1rem; transition:all 0.15s; background:var(--cf-surface-alt); color:var(--cf-muted); }
.cf-iconbtn--primary:hover { background:rgb(var(--primary) / 0.12); color:rgb(var(--primary)); }
.cf-iconbtn--danger:hover { background:rgb(var(--danger) / 0.12); color:rgb(var(--danger)); }
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }
@media (max-width:768px) { .cf-dialog--xxl { max-width:100%; } }
</style>